import React, { memo, useContext } from "react";

import { TableCell, TableRow } from "@mui/material";

import { useState } from "react";
import { withRouter } from "react-router";
import AuthContext from "../../../../Context/Auth/AuthContext";
import {
  Cancel,
  CopyAll,
  Create,
  DeleteForever,
  HistoryToggleOff,
  PictureAsPdf,
  Restore,
} from "@mui/icons-material";
import {
  butonIconTransition,
  useRowStyles,
} from "../../../../styles/stylesRows";
import { usePermiso } from "../../../../hooks/usePermiso";
import {
  FechaExacta,
  serverphpvet,
  trimPropsItem,
} from "../../../../config/const";
import ConfirmacionDialog from "../../../components/Dialogs/ConfirmacionDialog";
import ButtonsAction from "../../../components/Tablas/ButtonsAction";
import CallNombrePersona from "../../../components/Tablas/CallNombrePersona";
import clienteAxios from "../../../../config/axios";
import AlertaContext from "../../../../Context/Alerta/AlertaContext";
const Row = (props) => {
  // CLASES
  const classes = useRowStyles();
  // PROPS
  const {
    arrayExport,
    setarrayExport,
    row,
    index,
    campoExport,
    seteditar,
    setopen,
    changeObjetoActivoState,
    socket,
    seteditarFactura,
    changeObjetoActivoStateFactura,
    setopenFactura,
    // ObjectoActivoFactura,
  } = props;
  const claseCelda = `${
    index % 2 === 0 ? classes.celda : classes.celdaSecundario
  } ${
    row.editado === true
      ? classes.celdaEditado
      : row.nuevo === true
      ? classes.celdaNuevo
      : row.eliminado === true
      ? classes.celdaEliminado
      : ""
  }`;
  // HOOK DE PERMISO
  const { tienePermiso, alertaPermiso } = usePermiso("LaboratorioClinico");
  // CONTEXT
  const { usuario } = useContext(AuthContext);
  const { mostrarAlerta } = useContext(AlertaContext);
  // ABRE EL DIALOG DE CONFIRMACION
  const [openConfirmDialog, setopenConfirmDialog] = useState(false);
  const [openDialogHistorial, setOpenDialogHistorial] = useState(false);
  // STATE`
  const [celComprimida, setcelComprimida] = useState({});
  // ELIMINAR EL REGISTRO
  const handleEliminar = async (_id) => {
    try {
      socket.current.emit("client:eliminarData", {
        tabla: "laboratorio_clinico",
        rucempresa: usuario.rucempresa,
        rol: usuario.rol,
        lc_usuario: usuario.usuario,
        lc_empresa: usuario.rucempresa,
        [campoExport]: row[campoExport],
      });
      setopenConfirmDialog(false);
    } catch (error) {}
  };
  // FUNCION PARA EDITAR, ABRE EL MODAL COLOCA EN EDITAR EL MODAL Y CAMBIA EL OBJETO ACTIVO
  const funcionEdit = () => {
    setopen(true);
    seteditar(true);
    console.log({ row });

    changeObjetoActivoState({
      ...row,
      lc_fecha: row.lc_fecha.split("T")[0],
    });
  };
  const funcRecuperar = () => {
    try {
      socket.current.emit(
        "client:guardarData",
        trimPropsItem({
          ...row,

          tabla: "laboratorio_clinico",
          rucempresa: usuario.rucempresa,
          rol: usuario.rol,
          lc_usuario: usuario.usuario + "/+/" + row[campoExport],
          lc_empresa: usuario.rucempresa,
          [campoExport]: row[campoExport],
        })
      );

      seteditar(false);
    } catch (error) {}
  };
  return (
    <React.Fragment>
      <ConfirmacionDialog
        open={openConfirmDialog}
        setopen={setopenConfirmDialog}
        categoria="warning"
        titulo={`¿Esta seguro de eliminar este registro?`}
        botones={[
          {
            tooltip: "Se eliminaran los registros",
            texto: "SI",
            funcion: () => {
              handleEliminar();
            },
            disabled: false,
            Icon: DeleteForever,
            color: "error",
            id: 1,
            ocultar: false,
            tipo: "boton",
            variante: "contained",
            size: "medium",
            sx: { marginRight: ".3rem" },
          },
          {
            tooltip: "Cancelar",
            texto: "NO",
            funcion: () => {
              setopenConfirmDialog(false);
            },
            disabled: false,
            Icon: Cancel,
            color: "secondary",
            id: 2,
            ocultar: false,
            tipo: "boton",
            variante: "contained",
            size: "medium",
            sx: {},
          },
        ]}
      />
      <TableRow className={classes.root}>
        {/* boton */}
        <ButtonsAction
          claseCelda={claseCelda}
          arrayExport={arrayExport}
          setarrayExport={setarrayExport}
          campoExport={campoExport}
          row={row}
          botones={[
            {
              tooltip: "Eliminar",
              texto: "",
              funcion: () => {
                if (!tienePermiso("eliminar")) {
                  return alertaPermiso("eliminar");
                }
                setopenConfirmDialog(true);
              },
              disabled: false,
              Icon: DeleteForever,
              color: "error",
              id: 3,
              ocultar: false,
              tipo: "icono",
              variante: "contained",
              size: "small",
              sx: butonIconTransition,
            },
            {
              tooltip: "Editar Registro",
              texto: "",
              funcion: () => {
                if (!tienePermiso("editar")) {
                  return alertaPermiso("editar");
                }
                funcionEdit();
              },
              disabled: false,
              Icon: Create,
              color: "secondary",
              id: 1,
              ocultar: row.eliminado,
              tipo: "icono",
              variante: "contained",
              size: "small",
              sx: butonIconTransition,
            },
            {
              tooltip: "Copiar Registro",
              texto: "",
              funcion: () => {
                console.log({ row });

                setopen(true);
                changeObjetoActivoState({
                  ...row,
                  lc_id: 0,
                  lc_fecha: row.lc_fecha.split("T")[0],
                });
              },
              disabled: false,
              Icon: CopyAll,
              color: "secondary",
              id: 1,
              ocultar: row.eliminado,
              tipo: "icono",
              variante: "contained",
              size: "small",
              sx: butonIconTransition,
            },

            {
              tooltip: "PDF",
              texto: "",
              funcion: async () => {
                try {
                  window.open(
                    `${serverphpvet}reportes/laboratorio_clinico.php?id=${row.lc_id}&empresa=${row.lc_empresa}`,

                    "_blank"
                  );
                } catch (error) {
                  console.log({ error });
                  mostrarAlerta("Hubo un error", "error");
                }
              },
              disabled: false,
              Icon: PictureAsPdf,
              color: "error",
              id: 2,
              ocultar: row.eliminado,
              tipo: "icono",
              variante: "contained",
              size: "small",
              sx: butonIconTransition,
            },
          ]}
        />

        <>
          <TableCell size="small" align="center" className={claseCelda}>
            {row.lc_id}
          </TableCell>
          <TableCell size="small" align="center" className={claseCelda}>
            {row.lc_nombre_mascota}
          </TableCell>
          <TableCell size="small" align="center" className={claseCelda}>
            {row.lc_nombre_propietario}
          </TableCell>
          <TableCell size="small" align="center" className={claseCelda}>
            {row.lc_nombre_medico}
          </TableCell>
         
          <TableCell size="small" align="center" className={claseCelda}>
            {row.lc_observacion}
          </TableCell>

          <CallNombrePersona user={row.lc_usuario} claseCelda={claseCelda} />
          <TableCell size="small" align="center" className={claseCelda}>
            {new Date(row.lc_fec_upd).toLocaleString("es-ES", {
              weekday: "short",
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour: "2-digit",
            })}
          </TableCell>
        </>
      </TableRow>
    </React.Fragment>
  );
};

export default withRouter(memo(Row));
